import angular from "angular";
import carousel from "angular-ui-bootstrap/src/carousel";

const carouselInterval = 5000;

export default angular
  .module("controllers.marketablesTopMedia", [
    carousel,
  ])
  .controller("MarketablesTopMediaController", [
    "carouselImages", // defined on rails view

    function(
      carouselImages
    ) {
      this.carousel = {
        active: 0,
        images: carouselImages,
        interval: carouselInterval,
      };
    },
  ])
  .name;



// WEBPACK FOOTER //
// ./app/web/packs/angular/controllers/marketables-top-media-controller.js